import React, {useState} from 'react';
import './styles.css';
import Popup from './Popup';
import axios from 'axios';
import {Toast} from './SweetAlert';

/* eslint "require-jsdoc": [2, {
    "require": {
        "FunctionDeclaration": true,
        "MethodDefinition": false,
        "ClassDeclaration": false
    }
}]*/
/**
* @return {html} Profile Card.
 @param {Object} props
*/
function ProfileCard(props) {
  const [isOpen, setIsOpen] = useState(false);
  const [slider, setSlider] = useState(0);

  const togglePopup = () => {
    setIsOpen(!isOpen);
  };
  const slide = (e) => {
    setSlider(e.target.value);
    const promocode = props.promocode;
    const voucherId = props.voucherId;
    if (e.target.value >= 670) {
      e.target.value = 0;
      axios.delete(`https://blooming-springs-86289.herokuapp.com/api/member/${voucherId}`)
          .then((response) => {
            Toast.fire({
              icon: 'success',
              title: 'Success!',
              text: 'Voucher successfully Used! The promocode is ' + promocode,
            });
            setIsOpen(false);
          })
          .catch((error) => {
            Toast.fire({
              icon: 'error',
              title: 'Error!',
            });
            setIsOpen(false);
          }).finally(() => {
            props.updateVouchers(true);
          });
    }
  };

  return (
    <>
      <div className="container2">
        <div className="vouchercard">
          <div className="main">
            <div id="coupon-amount">${props.amount} Voucher</div>
            <div className="content">
              <div className='redeem-button'>
                <input className='clickme'
                  type="button"
                  value="Use Now"
                  onClick={togglePopup}
                />
                <div className='popup'>
                  {isOpen && <Popup
                    content={<>
                      <b>Are you sure you want to use this
                        ${props.amount} voucher?</b>
                      <p>Slide to Confirm</p>
                      <div className="confirmation-slider">
                        <div id="status">
                          <input id="confirm" type="range"
                            min="0" max="710" onChange={(e) => slide(e)}
                            value={slider} />
                        </div>
                      </div>
                    </>}
                    handleClose={togglePopup}
                  />}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>


  );
}

export default ProfileCard;
